import { createFileRoute } from "@tanstack/react-router";
import { PerfilPage } from "@/paginas/usuario-perfil";

export const Route = createFileRoute("/_authenticated/usuario-perfil")({
  head: () => ({
    meta: [
      { title: "Perfil do usuário — Milky Moo Palmares" },
      {
        name: "description",
        content: "Veja o e-mail usado no acesso e escolha a sua foto de perfil no sistema.",
      },
      { property: "og:title", content: "Perfil do usuário — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Dados da sua conta de acesso e troca da foto de perfil.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PerfilPage,
});
